import { call, put, select } from 'redux-saga/effects';
import { updateMyContacts as updateMyContactsAda } from '@bitComponents/adabyron/client';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* updateMyContacts(params) {
  const {
    reduxUpdate,
    newContactEmail,
    newContactPhone,
    additionalInfo,
    cqId,
    normalizeHttpErrors,
    webServiceName = WEB_SERVICES.UPDATE_MY_CONTACTS,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = {
      newContactEmail,
      newContactPhone,
      additionalInfo,
      cqId,
    };
    const response = yield call(updateMyContactsAda, args, context);
    yield put(successUpdate(response));

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, webServiceName, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
